export const listMutations = <const>{
	VOZIDLO_FILTER_SELECT_MAPPER: 'VOZIDLO_FILTER_SELECT_MAPPER',
	PRACOVNIK_FILTER_SELECT_MAPPER: 'PRACOVNIK_FILTER_SELECT_MAPPER',
};

export const editMutations = <const>{
	VOZIDLO_SELECT_MAPPER: 'VOZIDLO_SELECT_MAPPER',
	PARTNER_SELECT_MAPPER: 'PARTNER_SELECT_MAPPER',
	UPDATE_CHECKIN_AFTER_MERGE: 'UPDATE_CHECKIN_AFTER_MERGE',
	CREATED_ZAKAZKA: 'CREATED_ZAKAZKA',
	VOZIDLO_CHANGE: 'VOZIDLO_CHANGE',
};

export const actions = <const>{
	VOZIDLO_CHANGE: 'VOZIDLO_CHANGE',
};
